import { render } from "./WarningConfirm.vue?vue&type=template&id=33e0a972&ts=true"
import script from "./WarningConfirm.vue?vue&type=script&lang=ts"
export * from "./WarningConfirm.vue?vue&type=script&lang=ts"

import "./WarningConfirm.vue?vue&type=style&index=0&id=33e0a972&lang=scss"

import exportComponent from "/opt/esim/admin-src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__